export const flightType = {
  roundTrip: "Return",
  oneWay: "Oneway",
  multiCity: "Multi-City",
};
